export default "__VITE_ASSET__B$Evu5EL__"